import { Outlet } from 'react-router-dom';

const FleetLayout = () => {
  return <Outlet />;
};

export default FleetLayout;
